import angular from 'angular';
import csmCommonWeb from 'csm-common-web';
import booksData from '../../../data/data';
import booksSvc from '../../../util/BooksSvc/BooksSvc';
import mergeEntityDialogTemplate from './mergeEntityDialog.template.html';

export default angular
  .module('books.dialogs.entities.mergeEntityDialog', [
    csmCommonWeb,
    booksData,
    booksSvc
  ])
  /*******************************************************************************
   * Service: MergeEntityDialog */
  /**
   * @ngdoc  service
   * @module books.dialogs.entities
   * @name   books.dialogs.entities.mergeEntityDialog.service:MergeEntityDialog
   *
   * @description
   * Utility to show a dialog to print entities.
   *******************************************************************************/
  .service('MergeEntityDialog', MergeEntityDialog).name;

/*******************************************************************************
 * MergeEntityDialog */
/**
 * @param $uibModal
 * @returns
 *******************************************************************************/
/* @ngInject */
function MergeEntityDialog($uibModal) {
  /** Dialog Controller. */
  function MergeEntityDialogController(
    $scope,
    $uibModalInstance,
    Alert,
    BooksSvc,
    BusyScreen,
    destinationID,
    entityName,
    entityList,
    uiGridConstants
  ) {
    /*------------------*/
    /* View Properties. */
    /*------------------*/
    /** Name of entity to merge to. */ $scope.entityName = entityName;

    /*------------------------------------------------*/
    /* List of all available entities to select from. */
    /*------------------------------------------------*/
    $scope.dgEntities = {
      enableColumnMenus: false,
      enableFiltering: true,
      enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
      enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      minRowsToShow: 9,
      onRegisterApi: function (gridApi) {
        $scope.dgEntities.api = gridApi;
      },
      data: [],
      columnDefs: [
        {
          cellTemplate:
            '<div class="ui-grid-cell-contents" style="white-space:normal">' +
            '  <span style="max-width:90%; text-overflow: ellipsis;">{{grid.getCellValue(row, col)}}</span>' +
            '  <button class="pull-right" ng-click="grid.appScope.addEntity(row.entity)">' +
            '    <span class="glyphicon glyphicon-arrow-right"></span>' +
            '  </button>' +
            '</div>',
          displayName: 'Choose From',
          field: 'labelFunction'
        }
      ]
    };

    /*--------------------------------*/
    /* List of entities to be merged. */
    /*--------------------------------*/
    $scope.dgMergeList = {
      enableColumnMenus: false,
      enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
      enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      minRowsToShow: 10,
      onRegisterApi: function (gridApi) {
        $scope.dgMergeList.api = gridApi;
      },
      data: [],
      columnDefs: [
        {
          cellTemplate:
            '<div class="ui-grid-cell-contents" style="white-space:normal">' +
            '  <button ng-click="grid.appScope.removeEntity(row.entity)">' +
            '    <span class="glyphicon glyphicon-arrow-left"></span>' +
            '  </button>' +
            '  <span style="max-width:90%; text-overflow: ellipsis;">{{grid.getCellValue(row, col)}}</span>' +
            '</div>',
          displayName: 'To Be Merged',
          field: 'labelFunction'
        }
      ]
    };

    /***************************************************************************
     * addEntity */
    /**
     * Add entity button click handler in dgEntities cellTemplate. Moves the
     * entity to the merge list and refreshes the list.
     *
     * @param   entity   Entity to be moved.
     ***************************************************************************/
    $scope.addEntity = function (entity) {
      $scope.dgMergeList.data.unshift(entity);
      refreshEntities();
    };

    /***************************************************************************
     * commit */
    /**
     * Merge button click handler. Confirms decisions before calling service.
     * Closes the dialog on successful merge.
     ***************************************************************************/
    $scope.commit = function () {
      /*----------------------------------*/
      /* Nothing provided to merge, exit. */
      /*----------------------------------*/
      if ($scope.disableMerge()) {
        Alert.error('Please select at least one person to merge with.');
        return;
      }

      /*----------------*/
      /* Confirm merge. */
      /*----------------*/
      Alert.confirm(
        'The merge cannot be undone. Are you sure you wish to continue?',
        'Confirm Merge'
      ).then(function () {
        BusyScreen.setBusy(true);

        /*--------------------------------*/
        /* List of IDs to be merged with. */
        /*--------------------------------*/
        var dropIDs = $scope.dgMergeList.data.map(function (eli) {
          return eli.id;
        });

        BooksSvc.mergeEntities(destinationID, dropIDs).then(
          function (resp) {
            BusyScreen.setBusy(false);
            $uibModalInstance.close();
          },
          /*-----------------------------*/
          /* Service call error handler. */
          /*-----------------------------*/
          function (resp) {
            Alert.error(resp.parsedResponse.message(), 'Merge Error');
          }
        );
      });
    };

    /***************************************************************************
     * disableMerge */
    /**
     * Returns an indication to disable/enable the merge button. Merge button is
     * disabled when no entities have been added to be merged with.
     *
     * @return   Boolean  True=Merge btn should be disabled.
     ***************************************************************************/
    $scope.disableMerge = function () {
      return $scope.dgMergeList.data.length < 1;
    };

    /***************************************************************************
     * refreshEntities */
    /**
     * Filter the list of available entities list to exclude the destination entity
     * and those not selected to be merged with.
     ***************************************************************************/
    function refreshEntities() {
      $scope.dgEntities.data = entityList.filter(function (eli) {
        return (
          eli.id != destinationID &&
          !$scope.dgMergeList.data.some(function (meli) {
            return meli.id == eli.id;
          })
        );
      });
    }

    /***************************************************************************
     * removeEntity */
    /**
     * Remove entity button click handler in dgMergeList cellTemplate. Removes the
     * entity from the merge list.
     *
     * @param   entity   Entity to be moved.
     ***************************************************************************/
    $scope.removeEntity = function (entity) {
      var pos = $scope.dgMergeList.data.indexOf(entity);
      $scope.dgMergeList.data.splice(pos, 1);
      refreshEntities();
    };

    /*-----------------------------------------------------*/
    /* Setup the initials list of entities for the dialog. */
    /*-----------------------------------------------------*/
    refreshEntities();
  }

  /****************************************************************************
   * show */
  /**
   * Show the modal dialog for merging entities.
   *
   * @param   destinationID  Destination Entity ID
   * @param   entityName     Destination Entity Name for display.
   * @param   entityList     Available Entity List.
   * @return                 Promise that resolves when the modal dialog is closed.
   ****************************************************************************/
  this.show = function (destinationID, entityName, entityList) {
    return $uibModal.open({
      animation: true,
      backdrop: 'static',
      controller: MergeEntityDialogController,
      size: 'lg',
      resolve: {
        destinationID: function () {
          return destinationID;
        },
        entityName: function () {
          return entityName;
        },
        entityList: function () {
          return entityList;
        }
      },
      template: mergeEntityDialogTemplate
    }).result;
  };
}
